import React       from 'react';
import ReactDom    from 'react-dom';

import Utils       from 'utils';
// -------------------------------------------------------

class CustomUrls extends React.Component {
  getValues(){
    let ary = [];
    try { ary = JSON.parse(this.props.update.custom_urls); } catch(e) {}
    if( ary == undefined || ary.length == 0 ) ary = [{ id: Utils.getUniqueID(), name: '', url: '' }];
    return ary;
  }
  // -------------------------------------------------------
  
  check(ary) {
    
    // 空白のみの欄を削除
    ary = ary.filter((d) => { if( d.name != '' || d.url != '' ) return d; });
    
    // 全部埋めている場合は新規追加
    let next = true;
    ary.map((d) => { if( d.name == '' || d.url == '' ) next = false; });
    if( next == true && ary.length <= 2 ) ary.push({ id: Utils.getUniqueID(), name: '', url: '' });
    
    // データがない場合はリセット
    if( ary == undefined || ary.length == 0 ) ary = [{ id: Utils.getUniqueID(), name: '', url: '' }];
    
    return ary;
  }
  // -------------------------------------------------------
  
  update(id, name, url) {
    let ary = this.getValues.bind(this)();
    ary = ary.map((d) => {
      if( d.id == id ){
        d.name = name;
        d.url  = url;
      }
      return d;
    });
    
    ary = this.check.bind(this)(ary);
    this.props.update_ev.bind(this)(JSON.stringify(ary));
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    let ary = this.getValues.bind(this)();
    
    return (
      <div className="custom-urls">
        { ary.map((d, key) => {
          return <CustomUrlInput key={key} data={d} update_ev={this.update.bind(this)} />
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

class CustomUrlInput extends React.Component {
  update() {
    let name = this.name.value;
    let url  = this.url.value;
    
    this.props.update_ev.bind(this)(this.props.data.id, name, url);
  }
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="custom-urls-item">
        <div className="set-name">
          <h6>リンク名</h6>
          <input className="text" type="text" ref={(input) => { this.name = input }} onChange={this.update.bind(this)} defaultValue={data.name} placeholder="リンク名" />
        </div>
        <div className="set-url">
          <h6>リンクURL</h6>
          <input className="text" type="text" ref={(input) => { this.url = input }} onChange={this.update.bind(this)} defaultValue={data.url} placeholder="リンクURL" />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default CustomUrls;